<template>
  <div class="wrapper" v-loading="loading">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" :rules="rules" inline>
        <el-form-item prop="data.traceCode" label="追溯码">
          <el-input
            v-model="listForm.data.traceCode"
            placeholder="请输入精准追溯码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="no-info" v-if="haveInfo">没有查询到相关信息</div>
    <div v-if="traceCodeInfo.traceCode" class="trace-info-box">
      <div>
        <h3 class="trace-code-info-title">追溯码信息</h3>
        <div>
          <el-form
            :model="traceCodeInfo"
            ref="traceCodeInfo"
            label-width="120px"
            class="trace-code-info"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item label="追溯码：">
                  <span>{{ traceCodeInfo.traceCode }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请时间：">
                  <span v-if="traceCodeInfo.tracecodeApply">{{
                    traceCodeInfo.tracecodeApply.applyTime
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div>
        <h3 class="trace-code-info-title">物料信息</h3>
        <div>
          <el-form
            :model="traceCodeInfo"
            ref="traceCodeInfo"
            label-width="120px"
            class="trace-code-info"
          >
            <el-row>
              <el-col :span="6">
                <el-form-item label="物料名称：">
                  <span v-if="traceCodeInfo.productImportLibrary">{{
                    traceCodeInfo.productImportLibrary.productName
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="物料编码：">
                  <span v-if="traceCodeInfo.productImportLibrary">{{
                    traceCodeInfo.productImportLibrary.productCode
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="物料类型：">
                  <span v-if="traceCodeInfo.productionProduct">{{
                    traceCodeInfo.productionProduct.productionType
                      .productTypeName
                  }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="物料品牌：">
                  <span v-if="traceCodeInfo.productionProduct">{{
                    traceCodeInfo.productionProduct.productBrand
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="批次号："
                  ><span v-if="traceCodeInfo.productImportLibrary">{{
                    traceCodeInfo.productImportLibrary.productBatchNum
                  }}</span>
                </el-form-item></el-col
              >
              <el-col :span="6">
                <el-form-item label="生产日期：">
                  <span v-if="traceCodeInfo.productImportLibrary">{{
                    traceCodeInfo.productImportLibrary.madeDate | dateformat
                  }}</span>
                </el-form-item></el-col
              >
              <el-col :span="6">
                <el-form-item label="所属工厂：">
                  <span v-if="traceCodeInfo.tracecodeApply">{{
                    traceCodeInfo.tracecodeApply.companyName
                  }}</span>
                </el-form-item></el-col
              >
            </el-row>
          </el-form>
        </div>
      </div>
      <div>
        <h3 class="trace-code-info-title">扫码信息</h3>
        <div style="margin: 20px 0 0 20px">总扫码次数：{{ scanCount }}</div>
        <el-table :data="scanLogList" border style="margin-top: 20px">
          <el-table-column label="扫码时间" prop="scanTime" align="center">
          </el-table-column>
          <el-table-column label="扫码地点" align="center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.provCode | getprov }}
              </span>
              <span v-if="scope.row.cityCode">
                - {{ scope.row.cityCode | getprov }}
              </span>
              <span v-if="scope.row.areaCode">
                - {{ scope.row.areaCode | getprov }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { queryTraceByCode } from "@/common/api.js";
import options from "@/common/province.json";
export default {
  data() {
    return {
      listForm: {
        pageNum: "1",
        pageSize: "10",
        data: {
          traceCode: "",
        },
      },
      options: options,
      traceCodeInfo: {},
      scanLogList: [],
      haveInfo: false,
      loading: false,
      scanCount: 0,
      rules: {
        "data.traceCode": [
          { required: true, message: "请输入追溯码", trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    flowType(value) {
      switch (value) {
        case "1":
          return "生产入库";
          break;
        case "2":
          return "销售出库";
          break;
        case "3":
          return "退货入库";
          break;
        case "4":
          return "召回入库";
          break;
        case "5":
          return "销毁出库";
          break;
      }
    },
    physicDetailType(val) {
      switch (val) {
        case "1":
        case 1:
          return "麻醉药品原料药";
          break;
        case "2":
        case 2:
          return "第一类精神药品原料药";
          break;
        case "3":
        case 3:
          return "第二类精神药品原料药";
          break;
        case "4":
        case 4:
          return "麻醉药品";
          break;
        case "5":
        case 5:
          return "第一类精神药品";
          break;
        case "6":
        case 6:
          return "第二类精神药品";
          break;
        case "7":
        case 7:
          return "中药注射剂";
          break;
        case "8":
        case 8:
          return "疫苗";
          break;
        case "9":
        case 9:
          return "血液制品";
          break;
        case "10":
        case 10:
          return "国家基本药品目录入网药品";
          break;
        case "11":
        case 11:
          return "非基本药物";
          break;
        case "12":
        case 12:
          return "各省增补基本药物";
          break;
        case "13":
        case 13:
          return "特殊药品复方制剂";
          break;
        case "14":
        case 14:
          return "全品种进口药品";
          break;
        case "22":
        case 22:
          return "使用麻醉、第一类精神药品生产的普通药品";
          break;
        case "99":
        case 99:
          return "未分类";
          break;
      }
    },
    getprov(code) {
      if(!code){
        return
      }
      options.forEach((item, index) => {
        if (code == item.value) {
          code = item.label;
        } else if (item.children.length > 0) {
          item.children.forEach((c) => {
            if (code == c.value) {
              code = c.label;
            } else {
              if (c.children.length > 0) {
                c.children.forEach((cc) => {
                  if (code == cc.value) {
                    code = cc.label;
                  }
                });
              }
            }
          });
        }
      });
      return code;
    },
  },
  methods: {
    //   查询
    searchList() {
      this.$refs["listForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.traceCodeInfo = {};
          this.scanLogList = [];
          this.haveInfo = false;
          this.getPageList();
        }
      });
    },
    reset() {
      this.listForm = {
        pageNum: "1",
        pageSize: "10",
        data: {
          traceCode: "",
        },
      };
    },
    getPageList() {
      var params = this.listForm;
      queryTraceByCode(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          if (res.traceCode) {
            this.traceCodeInfo = res;
            this.scanLogList = res.scanLogList ? res.scanLogList : [];
            this.scanCount = res.scanCount;
          } else {
            this.haveInfo = true;
          }
          console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
      /deep/.el-form-item__content {
        width: 220px;
      }
    }
  }
  .el-row {
    // margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .dialog-Info /deep/.el-form-item {
    margin-bottom: 0;
  }
  .trace-code-info .el-form-item {
    margin-bottom: 5px;
  }
  .trace-info-box {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 20px;
    padding: 5px 15px 12px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  }
  .trace-code-info-title {
    margin-top: 20px;
    padding-left: 20px;
    color: #333333;
  }
  .no-info {
    text-align: center;
    font-size: 28px;
    color: #c4c4c4;
    margin-top: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/traceCode/traceCodeQuery.vue